import {ReactNode, useEffect} from "react";
import {authCheckRequest} from '../../api';
import {useRootDispatch} from '../../hooks';
import {setUserInfo} from '../../store/enaeaSlice';

export const AuthCheck = (props: { children: ReactNode }) => {
    const dispatch = useRootDispatch();
    useEffect(() => {
        authCheckRequest().then(res => {
            if (res.success) {
                dispatch(setUserInfo(res));
            }
        });
    }, []);
    return props.children ? props.children : null;
}
